import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import abstractBlock from '../../../components/AbstractBlock'
import SelectField from '../../form/components/SelectField'

const SelectCountry = ({ countries }) => <Field name='country' component={SelectField} options={countries} />

SelectCountry.propTypes = {
  countries: PropTypes.array
}

const mapStateToProps = state => ({
  countries: state.booking.countries ? Object.keys(state.booking.countries).reduce((a, b) => {
    a[state.booking.countries[b].code] = state.booking.countries[b].name
    return a
  }, []) : []
})

export default connect(mapStateToProps)(abstractBlock(SelectCountry))
